export default __webpack_public_path__ + "images/icons8-surveyWhite.svg";